import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import moment from 'moment-jalaali';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// تبدیل تاریخ‌ها به شمسی
const labels = ["2022-12-19", "2022-12-20", "2022-12-21", "2022-12-22", "2022-12-23", "2022-12-24", "2022-12-25", "2022-12-26", "2022-12-27", "2022-12-28", "2022-12-29", "2022-12-30", "2022-12-31", "2023-01-01"];
const persianLabels = labels.map(date => moment(date).format('jD jMMMM'));

const orderOverview = {
    labels: persianLabels,
    datasets: [
        {
            label: "درآمد",
            backgroundColor: "#8feac5",
            borderColor: 'transparent',
            hoverBorderColor: 'transparent',
            borderWidth: 2,
            data: [24200000, 18200000, 30000000, 50000000, 24500000, 18200000, 27000000, 50000000, 24000000, 26000000, 40000000, 23800000, 21200000, 17000000],
        },
        {
            label: "هزینه",
            backgroundColor: "#9cabff",
            borderColor: 'transparent',
            hoverBorderColor: 'transparent',
            borderWidth: 2,
            data: [17400000, 25000000, 18200000, 12000000, 16000000, 25000000, 18200000, 12000000, 17000000, 18200000, 14000000, 16000000, 19300000, 21000000],
        }
    ]
};

const options = {
    plugins: {
        legend: {
            display: false,
            labels: {
                boxWidth: 30,
                padding: 20,
                fontColor: '#6783b8'
            }
        },
        tooltip: {
            callbacks: {
                title: function (tooltipItem) {
                    return tooltipItem[0].label;
                },
                label: function (tooltipItem) {
                    const label = orderOverview.datasets[tooltipItem.datasetIndex].label || '';
                    return label + ': ' + new Intl.NumberFormat('fa-IR', { style: 'currency', currency: 'IRR' }).format(tooltipItem.raw);
                }
            },
            backgroundColor: '#eff6ff',
            titleFontSize: 13,
            titleFontColor: '#6783b8',
            titleMarginBottom: 6,
            bodyFontColor: '#9eaecf',
            bodyFontSize: 12,
            bodySpacing: 4,
            yPadding: 10,
            xPadding: 10,
            footerMarginTop: 0,
            displayColors: false
        }
    },
    scales: {
        y: {
            beginAtZero: true,
            ticks: {
                callback: function (value) {
                    return new Intl.NumberFormat('fa-IR', { style: 'currency', currency: 'IRR' }).format(value);
                },
                fontSize: 11,
                fontColor: '#9eaecf',
                padding: 10,
                min: 1000000,
                max: 50000000,
                stepSize: 12000000
            },
            grid: {
                color: '#52648420',
                zeroLineColor: '#52648420'
            }
        },
        x: {
            ticks: {
                fontSize: 9,
                fontColor: '#9eaecf',
                padding: 10
            },
            grid: {
                color: "transparent",
                zeroLineColor: 'transparent'
            }
        }
    },
    maintainAspectRatio: false,
    barPercentage: 0.8,
    categoryPercentage: 0.6
};

const CostsAndRevenue = () => {
    return (
        <div className="card ">
            <div className="card-inner">
                <div className="card-title-group pb-1 g-2 chart-title-bg">
                    <div className="card-title">
                        <h6 className="title">نمای کلی سفارشات</h6>
                        <p>نمای کلی درآمد و هزینه‌های شما در این ماه.</p>
                    </div>
                    <div className="card-tools shrink-0 d-none d-sm-block">
                        <ul className="nav nav-switch-s2 nav-tabs bg-white">
                            <li className="nav-item">
                                <a href="#" className="nav-link">۷ روز</a>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="nav-link active">۱ ماه</a>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="nav-link">۳ ماه</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="analytic-ov">
                    <div className="analytic-ov-ck">
                        <Bar data={orderOverview} options={options} />
                    </div>
                    <div className="chart-label-group ms-5">
                        <div className="chart-label">۱ دی, ۱۴۰۰</div>
                        <div className="chart-label d-none d-sm-block">۱۵ دی, ۱۴۰۰</div>
                        <div className="chart-label">۳۰ دی, ۱۴۰۰</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CostsAndRevenue;
